module.exports = __webpack_public_path__ + "static/media/Icon_PDF_2.d02eac7b.svg";